// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"fbe9dec4","453":"7c3fbac5","557":"46096371"}[chunkId] + ".chunk.js";
};